import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, PropertyType, ContextualField, AggregationMode, ScatterPlotConfiguration, NameBuilderConfiguration } from '../../../models';

import * as Fields from '../../../common/helpers/contextual';

class ScatterContextualController implements angular.IComponentController {
    cancel: () => void;
    configuration: ScatterPlotConfiguration;
    formController: angular.IFormController;
    isLoading: boolean;
    loadingMessage: string;
    properties: ContextualField[];
    save: () => void;

    private _originalConfiguration: ScatterPlotConfiguration;
    private garbages: (() => void)[] = [];

    static $inject = [
        '$scope',
        '$q'
    ];

    constructor(
        private _$scope: angular.IScope,
        private _$q: angular.IQService
    ) { }

    $onInit() {
        this.isLoading = true;

        this._originalConfiguration = angular.copy(this.configuration);
        this.initProperties();

        this.garbages.push(this._$scope.$watch(() => this.configuration, () => {
            _.find(this.properties, p => p.propertyName === 'aggregationPeriodProperty')
                .disabled = this.configuration.aggregation.mode === AggregationMode.None;
        }, true));

        this.isLoading = false;
    }

    $onDestroy() {
        this.garbages.forEach(g => g());
    }

    private initProperties() {
        if (!this.configuration.nameConfiguration) {
            this.configuration.nameConfiguration = new NameBuilderConfiguration(false);
        }
        if(this.configuration.alignedOn === undefined){
            this.configuration.alignedOn = 0;
        }

        this.properties = [
            angular.copy(Fields.Title),
            angular.copy(Fields.IsTitleVisible),
            angular.copy(Fields.IsLegendVisible),
            angular.copy(Fields.IsHorizontalGridLineVisibleDisplay),
            angular.copy(Fields.IsVerticalGridlinesVisibleDisplay),
            {
                modelName: 'isVisible',
                propertyType: PropertyType.Boolean,
                label: 'X axis title',
                placeholder: 'X axis title',
                propertyName: 'isXAxisTitleVisibleProperty',
                required: false,
                icon: 'fa-id-badge',
                iconText: 'X',
                extraData: {
                    subProperty: 'options.xAxis'
                }
            },
            {
                modelName: 'isVisible',
                propertyType: PropertyType.Boolean,
                label: 'Y axis title',
                placeholder: 'Y axis title',
                propertyName: 'isYAxisTitleVisibleProperty',
                required: false,
                icon: 'fa-id-badge',
                iconText: 'Y',
                extraData: {
                    subProperty: 'options.yAxis'
                }
            },
            {
                modelName: 'min',
                propertyType: PropertyType.Number,
                label: 'X min',
                placeholder: 'X min',
                propertyName: 'xMinProperty',
                required: false,
                icon: 'fa-long-arrow-left',
                extraData: {
                    subProperty: 'options.xAxis',
                    decimals: 0
                }
            },
            {
                modelName: 'max',
                propertyType: PropertyType.Number,
                label: 'X max',
                placeholder: 'X max',
                propertyName: 'xMaxProperty',
                required: false,
                icon: 'fa-long-arrow-right',
                extraData: {
                    subProperty: 'options.xAxis',
                    decimals: 0
                }
            },
            {
                modelName: 'min',
                propertyType: PropertyType.Number,
                label: 'Y min',
                placeholder: 'Y min',
                propertyName: 'yMinProperty',
                required: false,
                icon: 'fa-long-arrow-down',
                extraData: {
                    subProperty: 'options.yAxis',
                    decimals: 0
                }
            },
            {
                modelName: 'max',
                propertyType: PropertyType.Number,
                label: 'Y max',
                placeholder: 'Y max',
                propertyName: 'yMaxProperty',
                required: false,
                icon: 'fa-long-arrow-up',
                extraData: {
                    subProperty: 'options.yAxis',
                    decimals: 0
                }
            },
            angular.copy(Fields.AggregationMode),
            Fields.AggregationPeriodBuilder(this.configuration),
            angular.copy(Fields.MinPeriod),
            angular.copy(Fields.MaxPeriod),
            angular.copy(Fields.PeriodReference),
            angular.copy(Fields.IsEndDateIncluded),
            angular.copy(Fields.NameConfiguration.HasGroupName),
            angular.copy(Fields.NameConfiguration.HasName),
            angular.copy(Fields.NameConfiguration.HasShortComment),
            angular.copy(Fields.NameConfiguration.HasUnit),
            angular.copy(Fields.NameConfiguration.HasValueType)
        ];
    }

    onSave(): angular.IPromise<void> {
        return this._$q.when(this.save());
    }

    onCancel() {
        this.configuration = angular.copy(this._originalConfiguration);
        this.cancel();
    }
}

export const wtScatterContextual: ComponentDefinition = {
    componentId: 'wtScatterContextual',
    controller: ScatterContextualController,
    template: require('./scatterContextual.component.html'),
    controllerAs: 'vm',
    bindings: {
        formController: '=',
        configuration: '=',
        save: '&?',
        cancel: '&?'
    }
};